import { domainReplacer } from '../utils/domain-replacer';

export function redirectToInstallAX() {
  if (!$.browser.msie) {
    return;
  }

  var replaceURL = domainReplacer.create();

  /**
   * NOTE: appView 가 초기화 이전이므로 DOM에서 데이터를 바로 읽어온다.
   */
  var $state = $('.app__initial-state');
  var env = $state.data('env');
  var currentPage = window.encodeURIComponent(window.location.href);

  var axInstallGuide =
    env === 'live'
      ? 'https://file.pmang.com/nps/webboard/ax-install-guide/live/index.html'
      : 'https://file.pmang.com/nps/webboard/ax-install-guide/qa/index.html';

  // 피망 AX 미설치일 경우 설치 안내 페이지로 이동
  window.top.location.href = [replaceURL(axInstallGuide), '?return_url=', currentPage].join('');
}
